module.exports = __webpack_public_path__ + "static/media/PC_Carrosel_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-08.279f8904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Intel_em_Cybersecurity/PC_Carrosel_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-08.png
// module id = 191
// module chunks = 0